import React, { useState } from 'react';
import DarkImg from "./dark.png";
import LightImg from "./light.png";
import TransparentImg from "./transparent.png";
import Button from '../../../../../components/button';
import { updateVerifyToken } from '../../../../../services/medium';
import { copyToClipboard } from '../../../../../utils/helpers';

export default function ProfilePopUp({ id }) {
    const [copy, setCopy] = useState(false);
    const [copy2, setCopy2] = useState(false);
    const [copy3, setCopy3] = useState(false);
    const [width, setWidth] = useState(226);
    const [height, setHeight] = useState(213);
    const [width1, setWidth1] = useState(226);
    const [height1, setHeight1] = useState(213);
    const [width2, setWidth2] = useState(226);
    const [height2, setHeight2] = useState(213);


    const copyVerifiedBatch = (e, value) => {
        let location = window.location.origin;
        let url = `${location}/verysoul-verified-dark/${id}?width=${width}&height=${height}`;
        setCopy(true);
        e.stopPropagation();
        let body = {
            id: id,
            token_status: 2,
        };
        updateVerifyToken(body)
            .then(() => { })
            .catch(() => { });
        copyToClipboard(`<iframe frameborder="0"  width=${width} height=${height}  src="${url}"></iframe>`);
        setTimeout(() => {
            setCopy(false);
        }, 3000);
    };
    const copyVerifiedBatchDark = (e, value) => {
        let location = window.location.origin;
        let url = `${location}/verysoul-verified/${id}?width=${width1}&height=${height1}`;
        setCopy2(true);
        e.stopPropagation();
        let body = {
            id: id,
            token_status: 2,
        };
        updateVerifyToken(body)
            .then(() => { })
            .catch(() => { });
        copyToClipboard(`<iframe frameborder="0" width=${width1} height=${height1}  src="${url}"></iframe>`);
        setTimeout(() => {
            setCopy2(false);
        }, 3000);
    };
    const copyVerifiedBatchTransparent = (e, value) => {
        let location = window.location.origin;
        let url = `${location}/verysoul-verified-transparent/${id}?width=${width2}&height=${height2}`;
        setCopy3(true);
        e.stopPropagation();
        let body = {
            id: id,
            token_status: 2,
        };
        updateVerifyToken(body)
            .then(() => { })
            .catch(() => { });
        copyToClipboard(`<iframe frameborder="0" width=${width2} height=${height2}  src="${url}"></iframe>`);
        setTimeout(() => {
            setCopy3(false);
        }, 3000);
    };
    const handleWidthChange = (e) => {
        const value = e.target.value;

        if (/^\d*$/.test(value)) {
            const newWidth = parseInt(value || 0);
            setWidth(newWidth);
            setHeight(newWidth - 13);
        }
    };
    const handleHeightChange = (e) => {
        const value = e.target.value;

        if (/^\d*$/.test(value)) {
            const newHeight = parseInt(value || 0);
            setHeight(newHeight);
            setWidth(newHeight + 13);
        }
    };
    const handleWidthChange1 = (e) => {
        const value = e.target.value;

        if (/^\d*$/.test(value)) {
            const newWidth = parseInt(value || 0);
            setWidth1(newWidth);
            setHeight1(newWidth - 13);
        }
    };
    const handleHeightChange1 = (e) => {
        const value = e.target.value;

        if (/^\d*$/.test(value)) {
            const newHeight = parseInt(value || 0);
            setHeight1(newHeight);
            setWidth1(newHeight + 13);
        }
    };
    const handleWidthChange2 = (e) => {
        const value = e.target.value;

        if (/^\d*$/.test(value)) {
            const newWidth = parseInt(value || 0);
            setWidth2(newWidth);
            setHeight2(newWidth - 13);
        }
    };
    const handleHeightChange2 = (e) => {
        const value = e.target.value;

        if (/^\d*$/.test(value)) {
            const newHeight = parseInt(value || 0);
            setHeight2(newHeight);
            setWidth2(newHeight + 13);
        }
    }
    return (
        <div
            className="modal fade "
            id="profile-popup-verified-badge"
            data-backdrop="static"
            role="dialog"
        >
            <div className="modal-dialog modal-xl  modal-dialog-preview mt-10">
                <div className="modal-content">
                    <div className="modal-body">
                        <button type="button" class="close" data-dismiss="modal">
                            &times;
                        </button>
                        <div className="schedule-popup p-5">
                            {/* <img src="../images/new-cll.png" alt="user" /> */}

                            <h3 className="text-center">
                                Select Your Badge
                            </h3>

                            <div className='mt-2'>
                                <div className='d-flex justify-content-center gap-10 flex-wrap'>
                                    <div className='text-center'>
                                        <p className='font-weight-bold'>Black</p>
                                        <div className='w-200'>
                                            <img width={width} height={height} src={DarkImg} alt='dark' />

                                        </div>
                                        <div className='profile-size-container '>
                                            size : <input type='number' value={width} onChange={handleWidthChange} name='width' /> X <input onChange={handleHeightChange} value={height} type='number' name='height' />
                                        </div>
                                        <Button
                                            status={0}
                                            type="button"
                                            className={`resend-btn w-unset height-45 min-width-130px`}
                                            onClick={copyVerifiedBatch}
                                            title={copy ? "Copied" : "Copy"}
                                        />
                                    </div>
                                    <div className='text-center'>

                                        <p className='font-weight-bold'>White</p>
                                        <div className='w-200'>
                                            <img width={width1} height={height1} src={LightImg} alt='light' />
                                        </div>
                                        <div className='profile-size-container '>
                                            size : <input type='number' value={width1} onChange={handleWidthChange1} name='width' /> X <input onChange={handleHeightChange1} value={height1} type='number' name='height' />
                                        </div>
                                        <Button
                                            status={0}
                                            type="button"
                                            className={`resend-btn w-unset height-45 min-width-130px`}
                                            onClick={copyVerifiedBatchDark}
                                            title={copy2 ? "Copied" : "Copy"}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <p className='font-weight-bold'>Transparent</p>

                                        <div className='w-200'>
                                            <img width={width2} height={height2} src={TransparentImg} alt='light' />
                                        </div>
                                        <div className='profile-size-container '>
                                            size : <input type='number' value={width2} onChange={handleWidthChange2} name='width' /> X <input onChange={handleHeightChange2} value={height2} type='number' name='height' />
                                        </div>
                                        <Button
                                            status={0}
                                            type="button"
                                            className={`resend-btn w-unset height-45 min-width-130px`}
                                            onClick={copyVerifiedBatchTransparent}
                                            title={copy3 ? "Copied" : "Copy"}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


